<script>
    // @ts-nocheck

    export let value = null
    //   export let disabled = false;
    export let required = false
    export let label = null
    export let valid = true
    export let placeholder = ''
    export let options = []
    export let validation = (_) => true
    export let colorChip = '--color-grey-800'
    export let name = null
    export let inputValue = ''
    export let disabled = false
    import Chip from './Chip.svelte'
    import { getContext, onDestroy, createEventDispatcher } from 'svelte'
    import { writable } from 'svelte/store'
    const formData = getContext('formData')
    import { Typography, Button } from './'
    const dispatch = createEventDispatcher()
    function onUpdate() {
        dispatch('update')
    }
    function onEnter() {
        dispatch('enter')
    }
    function onDelete() {
        dispatch('delete')
    }
    function onAddItem() {
        dispatch('addItem')
    }
    const list = writable(value || [])
    function addItem(item) {
        if (
            !$list.includes(item) &&
            item &&
            item.replace(/\s+/g, '') &&
            validation(item)
        ) {
            list.update((all) => [...all, item])
            onAddItem()
            inputValue = ''
        }
    }
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: true,
                            validation: false,
                            required,
                            value,
                            label,
                            labelOption: null,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    $: if ($list) {
        value = $list
        onUpdate()
    }
    $: if (JSON.stringify(value) !== JSON.stringify($list)) {
        list.set(value)
    }
    $: valid = inputValue && validation(inputValue)
    $: _options =
        options?.map((x) =>
            ['string', 'number', 'bool'].includes(typeof x)
                ? { label: `${x}`, value: x }
                : x
        ) || []
    $: console.log({ _options })
</script>

<div style="width: 100%; position: relative" class:disabled>
    {#if label}
        <label for={name}
            ><Typography type="caption" color="caption">{label}</Typography
            ></label
        >
    {/if}
    <div class="container">
        <div class="textarea">
            <span style="width: 100%; display: flex; flex-direction: row">
                <input
                    {placeholder}
                    {disabled}
                    bind:value={inputValue}
                    type="text"
                    list="options"
                    on:keyup={(e) => {
                        if (e.key == 'Enter') {
                            onEnter('enter')
                            addItem(e?.target?.value)
                            console.log(e.target.value)
                        }
                    }}
                />
                {#if !disabled}
                    <Button
                        disabled={!valid || disabled}
                        label="Agregar"
                        size="small"
                        on:click={(_) => addItem(inputValue)}
                        style="min-width: 0; padding: 0 20px"
                    />
                {/if}
            </span>
            <datalist id="options">
                {#each _options.filter((x) => !$list.includes(x)) as { label, value } (value)}
                    <option {value}>{label}</option>
                {/each}
            </datalist>
            {#if $list.length > 0}
                {#each $list as item (item)}
                    {@const label =
                        _options.find((x) => x.value == item)?.label || item}
                    <Chip
                        closeable={!disabled}
                        color={colorChip}
                        {label}
                        on:close={(_) => {
                            list.update((all) => all.filter((x) => x !== item))
                            onDelete()
                        }}
                    />
                {/each}
            {:else}
                <slot name="empty" />
            {/if}
        </div>
    </div>
</div>

<style>
    .container {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        border: 1px solid #cccccc;
        border-radius: 8px;
        padding: 19px 16px;
        overflow: hidden;
        user-select: none;
    }

    input {
        border-style: none;
        outline: none;
        width: 100%;
        /* background-color: aqua; */
        padding: 5px;
    }
    input:disabled {
        background-color: inherit;
        cursor: no-drop;
    }

    .disabled {
        opacity: 0.5;
    }
    .container div {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        position: relative;
        border-style: none;
        background: transparent;
        box-sizing: border-box;
    }
</style>
